import SmallCircle from "../../reuseable/SmallCircle/SmallCircle";
import EducationMobileApps from "../../pages/MobileAppProjects/EducationMobileApps";
import "./MobileApp.css";
import Copyright from "../../reuseable/Copyright/Copyright";

import "swiper/css";

export default function MobileApp() {
  return (
    <div className="mobile_app_container container">
      <div className="mobile_app_header">
        <SmallCircle />
        <h1 className="product__title">Explore My Mobile Apps</h1>
      </div>

      <h4 className="mobileapp__subtitle">
        React Native ( iOs & Android App 📱 )
      </h4>
      <small className="mobileapp__description">
        Truly i build impactful mobile app to helps clients. I have skill React
        Native( DOC, Reanimated , Skia ) and so on 🌳.
      </small>

      <div className="mobileapp_project__container">
        <EducationMobileApps />
      </div>

      <Copyright />
    </div>
  );
}
